import { Actions, AppContext } from "@Context/common/general/context";
import { useApi } from "@hooks/index";
import { Api } from "@Shared/schemas";
import { useCallback, useContext } from "react";
import { defineNotificationModule, INotificationResolverProps } from "../notification-service.types";
import { useExclusiveMode } from "../shared/use-exclusive-mode";
import { useRecoveryNotification } from "../shared/use-recovery-notification";

const id = "USER_RECORD_RECOVERY";

const UserRecordRecoveryNotificationResolver = ({ priority }: INotificationResolverProps) => {
  const { dispatch, state } = useContext(AppContext);
  const isExclusiveMode = useExclusiveMode();

  const { call: createUserRecord } = useApi<typeof Api.Users.CreateUserRecord>({
    api: Api.Users.CreateUserRecord,
  });

  const recoveryRequest = useCallback(async () => {
    await createUserRecord();
  }, [createUserRecord]);

  const handleRecovered = useCallback(() => {
    dispatch({
      type: Actions.UsersActions.GetAccountInfo,
      disableLoaders: true,
    });
  }, [dispatch]);

  useRecoveryNotification({
    actionKey: "account.recovery.user.action",
    id,
    isActive: state.user.needsUserRecordRecovery && !isExclusiveMode,
    loadingKey: "account.recovery.user.loading",
    messageKey: "account.recovery.user.message",
    onRecovered: handleRecovered,
    priority,
    recoveryRequest,
    titleKey: "account.recovery.user.title",
  });

  return null;
};

export const userRecordRecoveryNotification = defineNotificationModule({
  id,
  Resolver: UserRecordRecoveryNotificationResolver,
});
